var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _mask, _path, _path2, _mask2, _path3, _path4, _rect7, _rect8, _rect9, _rect10, _rect11, _path5, _path6, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _circle, _path7, _path8, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightThemeThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 209,
    viewBox: "0 0 344 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 342,
    height: 207,
    rx: 9,
    fill: "white",
    stroke: "#CFD8DD",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 142,
    width: 60,
    height: 8,
    rx: 2,
    fill: "#0067DF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 142,
    width: 60,
    height: 8,
    rx: 2,
    fill: "#526069"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 161,
    width: 226,
    height: 8,
    rx: 2,
    fill: "#526069"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 173,
    width: 187,
    height: 8,
    rx: 2,
    fill: "#526069"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 142,
    width: 60,
    height: 8,
    rx: 2,
    fill: "#526069"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_1423_29569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 5.58172 5.58172 2 10 2H334C338.418 2 342 5.58172 342 10V30H2V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 5.58172 5.58172 2 10 2H334C338.418 2 342 5.58172 342 10V30H2V10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H342H2ZM342 31H2V29H342V31ZM2 30V2V30ZM342 2V30V2Z",
    fill: "#CFD8DD",
    mask: "url(#path-7-inside-1_1423_29569)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-2_1423_29569",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 30L31 207L10 207C5.58172 207 2 203.418 2 199L2.00001 30L31 30Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30L31 207L10 207C5.58172 207 2 203.418 2 199L2.00001 30L31 30Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 30L32 207L30 207L30 30L32 30ZM2 207L2.00001 30L2 207ZM2.00001 30L31 30L2.00001 30ZM31 207L2 207L31 207Z",
    fill: "#CFD8DD",
    mask: "url(#path-9-inside-2_1423_29569)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 319,
    y: 9,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#A4B1B8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 48,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#526069"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 72,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#0067DF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 96,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#526069"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 120,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#526069"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 12.5617V13.3881H43.8574V12.7637L43.5911 13.3881H43.4771L43.2016 12.7637V13.3881H43.0683V12.5617H43.2491L43.5246 13.2137L43.8195 12.5617H44ZM42.2698 12.5617H42.8877V12.6811H42.6594V13.3881H42.5074V12.6811H42.2698V12.5617ZM42.5074 15.9314V18.5299H41.3285V16.0601C41.3285 15.3805 40.9674 14.9397 40.2733 14.9397C39.5793 14.9397 39.1611 15.3989 39.1611 16.161V18.5299H37.9822V12.5617H39.1611V14.5175C39.4556 14.1778 39.9216 13.9942 40.5585 13.9942C41.6518 13.9942 42.5074 14.7561 42.5074 15.9314ZM36.9555 17.5566H37.4213V18.5299H36.8033C35.6815 18.5299 35.1967 18.0158 35.1967 16.9598V15.0225H34.6454V14.0584H35.1967V12.8371H36.3755V14.0584H37.4117V15.0225H36.3755V16.969C36.3755 17.3639 36.4992 17.5566 36.9555 17.5566ZM32.896 16.2988C32.896 15.5275 32.4206 14.9949 31.6696 14.9949C30.9188 14.9949 30.4528 15.4999 30.4528 16.2988C30.4528 17.0425 30.8712 17.5842 31.6696 17.5842C32.3923 17.5842 32.896 17.0792 32.896 16.2988ZM32.896 14.0584H34.075V18.5299H32.896V18.025C32.5824 18.3831 32.0879 18.5851 31.3941 18.5851C30.139 18.5851 29.2551 17.6301 29.2551 16.2988C29.2551 14.9766 30.1201 14.0032 31.3941 14.0032C32.0689 14.0032 32.5824 14.2328 32.896 14.6184V14.0584ZM27.734 14.7471C27.734 14.1226 27.363 13.7554 26.6881 13.7554H25.7469V15.7846H26.6881C27.363 15.7846 27.734 15.4174 27.734 14.7471ZM28.9317 14.7471C28.9317 15.9683 28.095 16.6936 26.8116 16.6936H25.7469V18.5299H24.568V12.8371H26.8116C28.1142 12.8371 28.9317 13.5717 28.9317 14.7471ZM19.8431 18.5299H21.022V14.0584H19.8431V18.5299ZM21.1551 12.8371C21.1551 13.2411 20.8508 13.5166 20.4326 13.5166C20.0144 13.5166 19.71 13.2411 19.71 12.8371C19.71 12.424 20.0144 12.1394 20.4326 12.1394C20.8508 12.1394 21.1551 12.424 21.1551 12.8371ZM17.7326 12.8371H18.9115V16.1702C18.9115 17.676 18.0273 18.5851 16.5348 18.5851C15.0707 18.5851 14.2055 17.6943 14.2055 16.1702V12.8371H15.3844V16.1702C15.3844 17.0058 15.7456 17.5107 16.5633 17.5107C17.3524 17.5107 17.7326 17.0333 17.7326 16.1702V12.8371ZM13.1789 19.8613H22.2104V11.1385H13.1789V19.8613ZM12 21H23.3892V10H12V21Z",
    fill: "#FA4616"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M284 30H342V199C342 203.418 338.418 207 334 207H284V30Z",
    fill: "#F4F5F7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 48.5,
    width: 225,
    height: 78,
    rx: 3.5,
    fill: "white",
    stroke: "#CFD8DD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 61,
    width: 93,
    height: 8,
    rx: 4,
    fill: "#526069"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 60,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#38C6F4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 79,
    width: 59,
    height: 8,
    rx: 4,
    fill: "#526069"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 78,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FFB40E"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 97,
    width: 77,
    height: 8,
    rx: 4,
    fill: "#526069"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 96,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#6EB84A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 88,
    r: 29,
    fill: "#6EB84A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94 58.5H93.5V59V88V88.5H94H123H123.532L123.499 87.9688C122.935 78.9424 119.957 72.9001 116.578 68.847C113.204 64.8001 109.452 62.7648 107.393 61.7153C103.245 59.6018 98.6554 58.5 94 58.5Z",
    fill: "#FFB40E",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 88L64.5 88.5L65 88.5L94 88.5L94.5 88.5L94.5 88L94.5 59L94.5 58.4678L93.9688 58.501C84.9424 59.0651 78.9001 62.043 74.847 65.4222C70.8001 68.7964 68.7648 72.5475 67.7153 74.6073C65.6018 78.7553 64.5 83.3446 64.5 88Z",
    fill: "#38C6F4",
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.9999,
    cy: 88,
    r: 15.6154,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightThemeThumbnail);
export default __webpack_public_path__ + "static/media/lightThemeThumbnail.5b3582d88d923760af513b1af41e9fcd.svg";
export { ForwardRef as ReactComponent };